import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, PeopleAlt as PhoneScrubIdentityIcon} from "@mui/icons-material"
import React from "react"

import {CustomerPhoneIdentityMatchActivityPayload} from "@indebted/api"

function PhoneIdentityScrubActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {Title: string; HappenedAt: string; Payload: CustomerPhoneIdentityMatchActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
	isIdentityMatched: boolean,
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<PhoneScrubIdentityIcon style={{color: isIdentityMatched ? "#2F853D" : "#E31D1D"}} />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Phone number:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Phone}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {PhoneIdentityScrubActivity}
